import {
  ComponentRef,
  inject,
  Injectable,
  PLATFORM_ID,
  Type,
  ViewContainerRef,
  signal,
  inputBinding,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class PopupModalService {
  private readonly platformId = inject(PLATFORM_ID);

  private hostViewContainerRef: ViewContainerRef | null = null;
  private activeComponentRef: ComponentRef<unknown> | null = null;

  readonly hasContent = signal(false);

  attachHost(hostViewContainerRef: ViewContainerRef): void {
    this.hostViewContainerRef = hostViewContainerRef;
  }

  open(component: Type<unknown>, inputs?: Record<string, unknown>): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    if (!this.hostViewContainerRef) {
      throw new Error(
        'PopupModalService host is not attached. Attach a host ViewContainerRef before calling open().',
      );
    }

    this.close();

    const bindings = Object.entries(inputs ?? {}).map(([key, value]) =>
      inputBinding(key, () => value),
    );
    this.activeComponentRef = this.hostViewContainerRef.createComponent(
      component,
      { bindings },
    );

    this.hasContent.set(true);
  }

  close(): void {
    this.activeComponentRef?.destroy();
    this.activeComponentRef = null;
    this.hostViewContainerRef?.clear();

    this.hasContent.set(false);
  }
}
